import { Tabs } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import type { AutoScheduleTabId } from '@/utils/autoScheduleFlags'

export function AutoScheduleTabList({
  tabs,
  value,
  onChange,
}: {
  tabs: AutoScheduleTabId[]
  value: AutoScheduleTabId
  onChange: (tab: AutoScheduleTabId) => void
}) {
  const { t } = useTranslation('scheduling')
  if (tabs.length === 0) {
    return null
  }
  return (
    <Tabs value={value} onChange={next => next && onChange(next as AutoScheduleTabId)} style={{ flexShrink: 0 }}>
      <Tabs.List>
        {tabs.map(tab => (
          <Tabs.Tab key={tab} value={tab}>
            {t(`autoSchedule.mode.${tab}`)}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  )
}
